import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { onPageEditing } from 'utils';

import Icon from 'components/Icon';
import ImageIcon from 'components/ImageIcon';
import Button from 'components/Button';
import OnScreen from 'components/OnScreen';

import css from './Infographic.module.scss';

import { THEMES, getThemeClassNames } from 'constants/themes';

class Infographic extends React.Component {
    static propTypes = {
        number: PropTypes.string,
        description: PropTypes.string,
        icon: PropTypes.string,
        iconNew: PropTypes.shape(ImageIcon.propTypes),
        unit: PropTypes.string,
        link: PropTypes.string,
        linkText: PropTypes.string,
        linkStyle: PropTypes.object,
        onScreen: PropTypes.bool,
        theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
    }

    static defaultProps = {
        linkStyle: {
            secondary: true
        }
    };

    state = {
        animate: false
    }

    componentDidMount() {
        if ((typeof window !== 'undefined') && window.matchMedia("(min-width: 1191px)").matches) {
            this.setState({ animate: true });
        }
    }

    render() {
        const overlaySize = 300;
        const { number, description, icon, iconNew, unit, link, linkText, linkStyle, onScreen, theme } = this.props;
        const finalLinkStyle = linkStyle ? linkStyle : { primary: true };

        const btnStyle = {
            ...finalLinkStyle,
            gray: theme === THEMES.yellow,
            light: theme === THEMES.darkgray
        };

        return (
            <div 
                className={cn(css.card, getThemeClassNames(css,theme), {
                    [css['is-visible']]: onScreen,
                    [css['has-animation']]: this.state.animate
                })}
            >
                <div className={css.circle}>
                    {this.state.animate &&
                        <svg
                            className={cn(css["circle-overlay"], {
                                [css["circle-overlay-hidden"]] : onScreen
                            })}
                            width={overlaySize}
                            height={overlaySize}
                            viewBox={`0 0 ${overlaySize} ${overlaySize}`}
                            style={{enableBackground: `new 0 0 ${overlaySize} ${overlaySize}`}}
                            x="0px" y="0px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve"
                        >
                            <circle
                                r={overlaySize/2}
                                cx={overlaySize/2}
                                cy={overlaySize/2}
                                strokeDasharray={Math.PI*overlaySize}
                                strokeDashoffset={onScreen ? (- Math.PI*overlaySize) : 0}
                            />
                        </svg>
                    }
                    <div className={css.content}>
                        <p
                            {...onPageEditing('Number')}
                            className={cn(css.number, {
                                [css.small]: number && number.length >= 4
                            })}
                        >{number}</p>
                        {(unit || iconNew || icon) && 
                            <p className={css.unit}>
                                {iconNew ? (
                                    <ImageIcon 
                                        className={cn(css.icon, {
                                            [css['icon-number']]: !!number
                                        })} 
                                        {...iconNew} 
                                    />
                                ) : 
                                    (icon ? (
                                        <Icon 
                                            className={cn(css.icon, {
                                                [css['icon-number']]: !!number
                                            })}
                                            icon={icon} 
                                        />
                                    ) : null)
                                }
                                {unit && <span {...onPageEditing('Unit')} className={css["unit-text"]}>{unit}</span>}
                            </p>
                        }
                    </div>
                </div>
                {description && 
                    <h3 className={css.description} {...onPageEditing('Description')}>
                        {description}
                    </h3>
                }
                {link && 
                    <Button {...btnStyle} className={css.button} title={linkText} href={link} {...onPageEditing('Link')}>
                        <span {...onPageEditing('LinkText')} >{linkText}</span>
                    </Button>
                }
            </div>
        );
    }
}

export default OnScreen(Infographic);



// WEBPACK FOOTER //
// ./src/components/Infographic/Infographic.jsx